export const projectClientTypeList = {
  hotel: "Hotel",
  school: "School",
  residential: "Residential",
};
export const PROJECT_CLIENT_TYPE_LIST = [
  { option: "Office", value: "Office" },
  { option: "School", value: "School" },
  { option: "College", value: "College" },
  { option: "Hospital", value: "Hospital" },
  { option: "Hotel", value: "Hotel" },
  { option: "Restaurant", value: "Restaurant" },
  { option: "Retail Store", value: "Retail Store" },
  { option: "Government Office", value: "Government Office" },
  { option: "Bank", value: "Bank" },
  { option: "Residential Project", value: "Residential Project" },
  { option: "Co-working Space", value: "Co-working Space" },
  { option: "Interior Designer", value: "Interior Designer" },
  { option: "Architect Firm", value: "Architect Firm" },
  { option: "Event Venue", value: "Event Venue" },
  { option: "Religious Institution", value: "Religious Institution" },
];
